module.exports = __webpack_public_path__ + "media/assets/images/votorantim-banco@3x-18713d32c58b1390adf17bdcdb8801f8.png";